module.exports = __webpack_public_path__ + "static/media/DSCF9184.ad2d719c.jpg";